// extracted by mini-css-extract-plugin
module.exports = {"lists":"Lists-styles_lists__2QfQ9","header":"Lists-styles_header___9GwJ","listOfLists":"Lists-styles_listOfLists__2HPaS","heading":"Lists-styles_heading__3bqGb"};